import { render, staticRenderFns } from "./notificationCreate.vue?vue&type=template&id=d3b29906&scoped=true&lang=html"
import script from "./notificationCreate.vue?vue&type=script&lang=js"
export * from "./notificationCreate.vue?vue&type=script&lang=js"
import style0 from "./notificationCreate.vue?vue&type=style&index=0&id=d3b29906&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b29906",
  null
  
)

export default component.exports